module.exports = "https://s81616.cdn.ngenix.net/home-frontend/_next/static/images/mite-e0cfacc2d794cb1b054630572833f3ce.png";